<template>
  <div>
    <!-- 导航栏-->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top top-nav-collapse" id="navbar">
      <div :class="isMobile ? 'phoneHeader' : 'navContainer'">
        <div class="navigationTitle">
          <div style="margin-top: 5px; width: 100%; text-align: center">
            <a class="titleItems" href="#"
              ><span id="shadow" :style="`${isMobile ? 'font-size: 14px' : 'font-size: 23px'}`"
                >电力工业电力设备及线路器材质量检验测试中心(福州国电电力设备质量检测有限公司)</span
              ></a
            >
          </div>
          <div v-if="!isMobile" style="margin-top: -5px; margin-bottom: 5px; width: 100%; text-align: center">
            <a class="titleItems" href="#"
              ><span id="shadow" style="font-size: 13px"
                >Power Industry Power Equipment and Transmission Material Inspection Test Center</span
              ></a
            >
          </div>
        </div>
        <div
          class="collapse navbar-collapse"
          :style="{
            flexGrow: 0,
            paddingLeft: `${clientWidth > 1200 ? '120px' : '10px'} !important`,
          }"
          v-if="!isMobile"
          id="navbarContent"
        >
          <ul class="navbar-nav ml-auto">
            <li class="nav-item" v-for="(item, index) in buttonList" :key="index">
              <div
                :id="isActive === item.src ? '' : 'shadow'"
                class="textItems"
                @click="jump(item.type, item.src)"
                :class="isActive === item.src ? 'isActive' : ''"
              >
                <div class="textChildTop">
                  <span>{{ item.zhName }}</span>
                </div>
                <div class="textChildDown">
                  <span>{{ item.enName }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="width: 100%" class="phoneHeaderButton" v-else>
          <div class="phone-item" v-for="(item, index) in buttonList" :key="index">
            <div @click="jump(item.type, item.src)" :class="isActive === item.src ? 'isActive' : ''">
              <div id="phone-items">
                <span>{{ item.zhName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    isActive: {
      type: String
    }
  },
  data() {
    return {
      buttonList: [
        {
          zhName: '首页',
          enName: 'Home',
          type: '#',
          src: '#'
        },
        {
          zhName: '关于我们',
          enName: 'About us',
          type: '#',
          src: '#about'
        },
        {
          zhName: '下载专区',
          enName: 'Download',
          type: 'router',
          src: 'Download'
        },
        {
          zhName: '证书查询',
          enName: 'Cert',
          type: 'router',
          src: 'Cert'
        },
        {
          zhName: '报告查询',
          enName: 'Report',
          type: 'router',
          src: 'Report'
        },
        {
          zhName: '在线委托',
          enName: 'Entrust',
          type: 'router',
          src: 'Entrust'
        },
        {
          zhName: '招聘信息',
          enName: 'Jobs',
          type: 'router',
          src: 'Jobs'
        },
        {
          zhName: '联系我们',
          enName: 'Contact',
          type: '#',
          src: '#contact'
        },
      ]
    };
  },
  methods: {
    jump(type, src) {
      switch (type) {
        case '#':
          let flag = ''
          switch (src) {
            case '#about':
              flag = 'about'
              break;
            case '#contact':
              flag = 'contact'
              break;
            default:
              flag = 'pageTop'
              break;
          }
          this.handleJumpRouter('Home', flag)
          break
        case 'router':
          this.handleJumpRouter(src)
          break
      }
    },
    handleJumpRouter(routerStr, sectionPath) {
      if (routerStr) {
        this.$router.push(
          {
            name: routerStr,
            params: { sectionPath: sectionPath }
          }
        )
        // router.push({
        //   name: routerStr,
        //   params: { sectionPath: sectionPath }
        // })
      }
    }
  },
  computed: {
    // 浏览器宽度
    clientWidth() {
      return Number(this.$store.state.clientWidth)
    },
    // 浏览器高度
    clientHeight() {
      return Number(this.$store.state.clientHeight)
    },
    // 是否为手机端
    isMobile() {
      return this.$store.state.isMobile
    }
  }
};
</script>
<style scoped>
#shadow {
  text-shadow: 0 0 5px black;
}
#shadow:hover {
  text-shadow: 0 0 0 black;
}
.textItems:hover span {
  color: black !important;
  font-weight: 500;
  transition: all 0.2s;
}
.navContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.phoneHeader {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
}
.phoneHeaderButton {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.phone-item {
  font-size: 12px;
  min-width: 60px;
  min-height: 20px;
  text-align: center;
}
#phone-items {
  color: #fff;
}
.jumpImg {
  width: 50px;
  height: 50px;
}
.jumpImg:hover {
  cursor: pointer;
}
.isActive span {
  color: rgb(26, 10, 10) !important;
  font-weight: bold;
}
.isActive:hover span {
  font-weight: bold;
}
.nav-item {
  min-width: 70px;
}
</style>
